module.exports = __webpack_public_path__ + "static/media/1-3.19c1d4c2.png";